"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Pages = _interopRequireDefault(require("./Pages"));

var _PageButtonLink = _interopRequireDefault(require("./PageButtonLink"));

var _MenuMeatballs = _interopRequireDefault(require("../../icons/MenuMeatballs"));

var MeatBalls = function MeatBalls() {
  return /*#__PURE__*/React.createElement(_MenuMeatballs.default, {
    size: "small",
    color: "primary"
  });
};

var CompactPages = function CompactPages(_ref) {
  var pageCount = _ref.pageCount,
      selectedPage = _ref.selectedPage,
      onPageChange = _ref.onPageChange,
      size = _ref.size;

  if (selectedPage > pageCount - 4) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_PageButtonLink.default, {
      onPageChange: onPageChange,
      size: size
    }, 1), /*#__PURE__*/React.createElement(MeatBalls, null), /*#__PURE__*/React.createElement(_Pages.default, {
      pageCount: 5,
      selectedPage: selectedPage,
      onPageChange: onPageChange,
      enlargement: pageCount - 4,
      size: size
    }));
  }

  if (selectedPage < 5) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Pages.default, {
      pageCount: 5,
      selectedPage: selectedPage,
      onPageChange: onPageChange,
      size: size
    }), /*#__PURE__*/React.createElement(MeatBalls, null), /*#__PURE__*/React.createElement(_PageButtonLink.default, {
      onPageChange: onPageChange,
      size: size
    }, pageCount));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_PageButtonLink.default, {
    onPageChange: onPageChange,
    size: size
  }, 1), /*#__PURE__*/React.createElement(MeatBalls, null), /*#__PURE__*/React.createElement(_Pages.default, {
    pageCount: 3,
    selectedPage: selectedPage,
    onPageChange: onPageChange,
    enlargement: selectedPage - 1,
    size: size
  }), /*#__PURE__*/React.createElement(MeatBalls, null), /*#__PURE__*/React.createElement(_PageButtonLink.default, {
    onPageChange: onPageChange,
    size: size
  }, pageCount));
};

var _default = CompactPages;
exports.default = _default;